import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import Button from '../../components/Button';
import Buttons from '../../components/Buttons';
import Form, { Field, Submit } from '../../components/Form';
import Modal, { ModalActionFooter, ModalTitle } from '../../components/Modal';

const REASONS = _.shuffle([
  'Switching to competitor',
  'Too expensive',
  'Too many issues or bugs',
  'Not enough usage',
]);

type Values = {
  reason?: string;
  details: string;
};

interface ChurnModalProps {
  onSubmit: (values: Values) => Promise<unknown>;
  close: () => void;
}

const ChurnModal = ({ onSubmit, close }: ChurnModalProps) => {
  const [reason, setReason] = useState('');
  const validateFormRef = useRef<(() => unknown) | null>(null);
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const requireDescription = reason === 'Other';

  // Make formik run the validation again after description field is rendered or not
  useEffect(() => {
    if (validateFormRef.current) {
      validateFormRef.current();
    }
  }, [requireDescription]);

  return (
    <Modal width={370}>
      <ModalTitle subtitle="Without an active subscription, all posts will become read-only.">
        Cancel your subscription?
      </ModalTitle>
      <Form<Values>
        onSubmit={(values) => onSubmit(values).then(close)}
        initialValues={{
          details: '',
        }}
      >
        {({ isValid, dirty, validateForm }) => {
          validateFormRef.current = validateForm;

          return (
            <>
              <Field
                name="reason"
                label="Reason for canceling"
                type="select"
                value={reason}
                onChange={setReason}
                placeholder="Choose a reason"
                options={[...REASONS, 'Other'].map((r) => ({
                  value: r,
                  label: r,
                }))}
                isSearchable={false}
                required
              />
              {requireDescription && (
                <Field
                  name="details"
                  label="Please describe"
                  type="textarea"
                  placeholder="Please provide feedback about why you are canceling. Thank you!"
                  required
                />
              )}
              <ModalActionFooter
                primary={
                  <Buttons>
                    <Button variant="secondary" onClick={close}>
                      Go back
                    </Button>
                    <Submit disabled={!isValid || !dirty}>Confirm</Submit>
                  </Buttons>
                }
              />
            </>
          );
        }}
      </Form>
    </Modal>
  );
};

export default ChurnModal;
